import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { getUserCustomSetting, patchUserCustomSetting, UserCustomSetting } from "../api/user";

import styled from "styled-components";
import { Card, FloatButton, Input, Layout, Modal } from "antd";

import { ViewerContext } from "./Viewer";
import Openseadragon from "../component/viewer/Custom-OpenSeadragon/openseadragon/build/openseadragon/openseadragon";
import { CommentsArea, TeachingTextArea, AnnoListArea, Viewer } from "../component/slideboard";
import { useRecoilState, useRecoilValue } from "recoil";

import { currentPostAtom, currentSlideAtom, initialSlide } from "../atom";
import { getSlideData, downloadSlide } from "../api/slideAPI";
import { deletePost, getPostData } from "../api/postAPI";
import { DeleteOutlined, LoadingOutlined } from "@ant-design/icons";
import { checkUser, checkUserName } from "../api/authAPI";
import FileSaver from "file-saver";
import { useBreadcrumbState } from "../hooks/useBreadcrumbState";

const SlideBoard = () => {
  const [currentPost, setCurrentPost] = useRecoilState(currentPostAtom);
  const [userName, setUserName] = useState<string>("");
  const [currentSlide, setCurrentSlide] = useRecoilState(currentSlideAtom);
  const [showDownloadBtn, setShowDownloadBtn] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const [userCustomSet, setUserCustomSet] = useState<UserCustomSetting>({
    useScaleBar: true,
    useMagnificationBar: true,
    useCaptureButton: true,
    useViewerRotationSlider: true,
    useGammaSlider: true,
    useViewerThumbnail: true,
    useAnnotation: true,
    useICCButton: true,
    userGammaValue: 1,
    useInvertedZoom: false,
  });

  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  // // Update breadcrumb state with slideboard info
  // useBreadcrumbState({
  //   boardId: params.boardId,
  //   title: currentPost?.title,
  //   categoryId: currentPost?.categoryId,
  //   mainCategory: categoryInfo?.mainCategory,
  //   chapterName: categoryInfo?.chapterName,
  // });

  const reloadAnnoList = async () => {
    if (currentPost.slides[0]) {
      const data = await getSlideData(currentPost.slides[0].slideId);
      setCurrentSlide(data);
    }
  };

  const reloadTeachingText = async () => {
    if (currentPost.slides[0]) {
      const data = await getSlideData(currentPost.slides[0].slideId);
      setCurrentSlide(data);
    }
  };

  const reloadComments = async () => {
    setCurrentPost(await getPostData(currentPost.id));
  };

  const handleDownload = async () => {
    setIsDownloading(true);
    const fileData = await downloadSlide(currentPost.slides[0].slideId);
    if(fileData === false) {
      setIsDownloading(false);
      window.alert("다운로드 권한이 없습니다.");
      return;
    }
    FileSaver.saveAs(fileData, currentPost.slides[0].filename);
    setIsDownloading(false);
  };

  const handleDeletePost = async () => {
    if (
      window.confirm(`해당 게시글을 삭제하시겠습니까?`)
    ) {
      const data = await deletePost(currentPost.id);
      navigate('/category?main=학생병원병리학실습&chapter=CNS');
    }
  };

  useEffect(() => {
    checkUserName().then((name) => {
      setUserName(name);
    });

    const getUserSetting = async () => {
      const userSet = await getUserCustomSetting();
      return setUserCustomSet(userSet);
    };

    getUserSetting();

    checkUser().then((role) => {
      setShowDownloadBtn(role === "ADMIN_MAIN" || role === "ADMIN_SUB" || role === "ADVISOR");
    });
  }, []);

  useEffect(() => {
    if (currentPost.slides[0]) {
      const slideId = currentPost.slides[0].slideId;
      getSlideData(slideId).then(setCurrentSlide);
    } else {
      setCurrentSlide(initialSlide);
    }
  }, [currentPost]);


  useEffect(() => {
    const updateUserSet = async () => {
      await patchUserCustomSetting(userCustomSet);
    };

    window.addEventListener("beforeunload", updateUserSet);

    return () => {
      window.removeEventListener("beforeunload", updateUserSet);
    };
  }, [userCustomSet]);

  useEffect(() => {
    const handleOutPath = async () => {
      await patchUserCustomSetting(userCustomSet);
    };

    return () => {
      handleOutPath();
    };
  }, [location, location.pathname, userCustomSet]);
  

  return (
    <ViewerContext.Provider value={{ userCustomSet, setUserCustomSet }}>
      <Layout.Content
        style={{
          minHeight: "80vh",
        }}
      >
        <div style={{ width: "80%", margin: "1rem auto", borderBottom: "1px solid #e0e0e0", paddingBottom: "1rem" }}>
          <h1>{currentPost.title}
            {userName === currentPost.writer && 
                <DeleteOutlined onClick={handleDeletePost} style={{ float: 'right', cursor: 'pointer' }} />
            }
          </h1>
          {/* {userName === currentPost.writer && <FloatButton icon={<DeleteOutlined />} />}  */}
        </div>
        {currentPost.slides[0] &&
          <>
            <Viewer postId={currentPost.id} slide={currentPost.slides[0]} />
            <div style={{ width: "80%", margin: "1rem auto", textAlign: "right" }}>
              {showDownloadBtn && <button onClick={handleDownload}>file download</button>}
            </div>
            <TeachingWrapper>
              <TeachingTextArea slideId={currentPost.slides[0].slideId} initialContent={currentPost.slides[0] ? currentPost.slides[0].description : ""} reloadTeachingText={reloadTeachingText}/>
            </TeachingWrapper>
            <BottomContainer>
              <CommentWrapper>
                <CommentsArea postId={currentPost.id} comments={currentPost.comments} reloadComments={reloadComments} />
              </CommentWrapper>
              <AnnoListWrapper>
                <AnnoListArea postId={currentPost.id} annoList={currentPost.slides[0] ? currentSlide?.annotations : []} reloadAnnoList={reloadAnnoList} />
              </AnnoListWrapper>
            </BottomContainer>
            {isDownloading && 
              <Modal open={isDownloading} centered closable={false} footer={null}>
                Downloading...  <LoadingOutlined />
              </Modal>
            }
          </>}
      </Layout.Content>
    </ViewerContext.Provider>
  );
};

const ViewerContainer = styled.div`
  width: 80%;
  margin: 0 auto;
  border: 1px solid #e0e0e0;
`;

const BottomContainer = styled.div`
  display: flex;
  width: 80%;
  margin: 1rem auto;
  gap: 1rem;
  border-top: 1px solid #e0e0e0;
  padding-top: 1rem;
`;

const CommentWrapper = styled.div`
  flex: 6.5;
`;

const AnnoListWrapper = styled.div`
  flex: 3.5;
`;

const TeachingWrapper = styled.div`
  width: 80%;
  margin: 1rem auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
`;

export default SlideBoard;